import {
  DailyFreeTimeModel,
  DailyFreeTimeUpdateModel,
} from "@/interface/reportform";
import {
  FetchResult,
  FetchResultBase,
  FetchWithToken,
  GetJsonWithToken,
} from "../apihandler";

export function GetDailyFreeTime(): Promise<
  FetchResult<DailyFreeTimeModel | null>
> {
  return GetJsonWithToken<DailyFreeTimeModel | null>(
    `api/DriverAPI/GetDailyFreeTime`,
  );
}

export function UpsertDailyFreeTime(
  model: DailyFreeTimeUpdateModel,
): Promise<FetchResultBase> {
  return FetchWithToken(`api/DriverAPI/UpsertDailyFreeTime`, {
    method: "POST",
    body: JSON.stringify(model),
  });
}
